import { shouldTrackSearchCount, countSearchFor } from './trackSearchCount'

export const trackSearchResultsDisplay = currentSite => {
  if (shouldTrackSearchCount(currentSite)) {
    countSearchFor(currentSite)
  }
}
